import ScheduleDetailLayout from '@/layouts/ScheduleDetail';

export const unstable_settings = {
  initialRouteName: 'index',
};

export default function PrivateTabsOrganizationScheduleScheduleAEventIdLayoutRoute() {
  return (
    <ScheduleDetailLayout basePath="/organization/schedule/(scheduleA)/[eventId]" />
  );
}
